<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>修改密码</p>
    </div>
    <div class="panel-content center_content">
      <div class="container">
        <div
          class="tips"
          v-if="checkDate"
        >
          <span>i</span>您已经180天未更换密码，为了确保您的账号安全，请及时修改密码
        </div>
        <form id="itemForm">
          <div class="item">
            <span class="title long">原始密码</span>
            <input
              type="password"
              value=""
              class="t-input"
              v-model="formInfo.oldPassword"
            >
          </div>
          <div class="item">
            <span class="title long">新密码</span>
            <input
              type="password"
              value=""
              class="t-input"
              v-model="formInfo.password1"
            >
          </div>
          <div class="item">
            <span class="title long">确认新密码</span>
            <input
              type="password"
              value=""
              class="t-input"
              v-model="formInfo.password2"
            >
          </div>
        </form>
        <span
          class="submitBtn"
          @click="changePassword"
        >提交</span>
        <div class="tip">
          <p>1、密码长度8-64位</p>
          <p>2、须同时包含大写字母、小写字母、数字、特殊字符中的任意三种</p>
          <p>3、密码不能包含邮箱</p>
          <p>4、180天内需更换一次密码</p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PassWord',
  data() {
    return {
      userprofile: null,
      formInfo: {
        oldPassword: '',
        password1: '',
        password2: ''
      }
    }
  },
  computed: {
    checkDate() {
      let days
      if (this.userprofile) {
        var _this = this
        const yy = new Date().getFullYear()
        const mm = new Date().getMonth() + 1
        const dd = new Date().getDate()
        _this.gettime = yy + '-' + mm + '-' + dd
        const d1 = new Date(this.userprofile.passDate)
        const d2 = new Date(_this.gettime)
        const rq = d2 - d1
        days = Math.ceil(rq / (24 * 60 * 60 * 1000))
      }
      return days > 180
    }
  },
  methods: {
    async changePassword () {
      var testPassword = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,64}$/
      var Email = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (this.formInfo.oldPassword.trim() === '') {
        this.$layer.msg('请输入新密码')
        return false
      } else
      if (this.formInfo.password1.trim() === '') {
        this.$layer.msg('请输入新密码')
        return false
      } else if (testPassword.test(this.formInfo.password1) === false) {
        this.$layer.msg('密码须同时包含大写字母、小写字母、数字、特殊字符中的任意三种')
        return false
      } else if (Email.test(this.formInfo.password1) === true) {
        this.$layer.msg('密码不能是邮箱')
        return false
      } else if (this.formInfo.password2.trim() === '') {
        this.$layer.msg('请输入确认密码')
        return false
      } else if (this.formInfo.password1.length < 8) {
        this.$layer.msg('密码至少8位')
        return false
      } else if (this.formInfo.password1.length > 64) {
        this.$layer.msg('密码最多64位')
        return false
      } else if (this.formInfo.password1 !== this.formInfo.password2) {
        this.$layer.msg('新密码和确认密码不一致')
        return false
      }
      await this.$http.post('/change_pwd/', {
        oldPassword: this.utils.encryptDes(this.formInfo.oldPassword),
        password1: this.utils.encryptDes(this.formInfo.password1),
        password2: this.utils.encryptDes(this.formInfo.password2)
      }).then((data) => {
        if (data.code === '200') {
          this.$layer.msg(data.msg)
          this.$router.push('/login')
        } else {
          this.$layer.msg(data.msg)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    async getUser () {
      const url = '/userprofile/' + this.$store.state.userInfo.profile_id + '/'
      await this.$http.get(url).then(async (data) => {
        if (data.id) {
          this.userprofile = data
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  mounted() {
    this.getUser()
  }
}
</script>

<style scoped lang="less">
.center_content {
  margin: 20px auto;
  width: 1200px;
  background: #fff;
  padding: 20px;
}
#itemForm {
  padding: 10px 0 0 0;
  margin-top: 30px;
  margin-left: 10px;
  .item {
    margin-bottom: 20px;
    .title {
      color: #444;
      margin-right: 20px;
      display: inline-block;
      width: 80px;
    }
    .t-input {
      border: 1px solid #dbdbdb;
      font-size: 14px;
      height: 32px;
      line-height: 32px;
      padding: 0 10px;
      width: 300px;
    }
  }
}

.submitBtn {
  background: #73D6CA;
  color: #fff;
  height: 34px;
  line-height: 34px;
  margin-left: 220px;
  padding: 8px 30px;
  cursor: pointer;
  border-radius: 5px;
}
.tip {
  margin-top: 40px;
  margin-left: 10px;
  p {
    color: #666;
    font-size: 14px;
    line-height: 24px;
  }
}
.item-verify {
  display: flex;
}
/deep/#itemForm .item-verify .t-input {
  width: 220px;
}
#itemForm .item-verify .code {
  width: 80px;
  line-height: 34px;
  background: #73D6CA;
  padding: 0;
  color: #fff;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
}
#itemForm .item .title {
  width: 93px;
}
.tips {
  color: #0033ff;
  margin-left: 10px;
  span {
    display: inline-block;
    width: 15px;
    height: 15px;
    background: #333;
    color: #fff;
    font-size: 12px;
    border-radius: 50%;
    text-align: center;
    font-weight: bold;
    margin-right: 5px;
  }
}
</style>
